import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog } from "../../components/dialog/dialogSlice";
import { TiLockClosedOutline } from "react-icons/ti";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import { IoOpen } from "react-icons/io5";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import {
  clearFilterCustomNBInquiry,
  clearNBinquiryDetails,
  setFilterCustomNBInquiry,
} from "./nbinquirySlice";
import { findAllActiveNBinquiry } from "./services/nbinquiry.services";
import { EDIT_ACCESS, INSERT_ACCESS } from "../../_contstants/common";
import { checkAcessRights } from "../../_helper/helper";
import { Tooltip } from "@progress/kendo-react-tooltip";
import _debounce from "lodash/debounce";
import { TextBox } from "@progress/kendo-react-inputs";
import { filterClearIcon } from "@progress/kendo-svg-icons";

const NBinquiry: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const isEditRef = React.useRef(false);
  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(clearNBinquiryDetails());
      if (!isEditRef.current) {
        dispatch(setCurrentPage(0));
        dispatch(clearFilterCustomNBInquiry());
      }
    };
  }, []);

  const handleNBinquiryCreate = () => {
    navigate("/nbinquiry/create");
  };
  return (
    <>
      {/* <DeleteNBinquiryDialog /> */}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            NB Inquiry List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleNBinquiryCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Create NB Inquiry
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <NBInquiryGridComponent isEditRef={isEditRef} />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const NBInquiryGridComponent: React.FC<{
  isEditRef: React.MutableRefObject<boolean>;
}> = ({ isEditRef }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const NBinquiryList = useAppSelector(
    (state) => state.nbinquiry.NBinquiryList
  );
  const loading = useAppSelector((state) => state.nbinquiry.loading);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  // const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomNBInquiry: any = useAppSelector(
    (state) => state.nbinquiry.FilterCustomNBInquiry
  );
  useEffect(() => {
    const payload = {
      ...FilterCustomNBInquiry,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(findAllActiveNBinquiry(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEditItem = (
      NBInquiryGUID: any,
      LeadID: any,
      LeadName: string
    ) => {
      navigate("/nbinquiry/edit", {
        state: { NBInquiryGUID, LeadID, LeadName },
      });
      isEditRef.current = true;
    };
    // const handleOpenDeleteDialog = (NBInquiryGUID: any) => {
    //   dispatch(openDialog("deleteNBinquiry"));
    //   dispatch(setNBinquiryID(NBInquiryGUID));
    // };

    return (
      <td className={`action-td ${props.className}`} style={props.style}>
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() =>
              handleEditItem(
                props.dataItem?.NBInquiryGUID,
                props.dataItem?.LeadID,
                props.dataItem?.LeadName
              )
            }
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}

        {/* <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
themeColor="error"
          onClick={() => handleOpenDeleteDialog(props.dataItem.NBInquiryGUID)}
        >
          <MdDelete
            className="absolute-position"
            style={{ fontSize: "24px" }}
          />
        </IconButton> */}
      </td>
    );
  };

  const MyNbInquiryStatusCheck = (props: GridCellProps) => {
    const handleLeadTypeStatus = (LeadGUID: any, InquiryStatus: any) => {
      navigate("/nbinquiry/Inquirylist", {
        state: { LeadGUID, InquiryStatus },
      });
    };

    return (
      <td className={`action-td ${props.className}`} style={props.style}>
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <Button
            style={{ marginRight: 5 }}
            themeColor={"primary"}
            type="button"
            fillMode="outline"
            size="small"
            title="Open"
            onClick={() =>
              handleLeadTypeStatus(props.dataItem.LeadGUID, {
                InquiryStatus: "OPEN",
                status: 0,
                LeadID: props.dataItem.LeadID,
                GroupCode: props.dataItem.GroupCode,
                OpenCount: props.dataItem.OpenCount,
                CloseCount: props.dataItem.CloseCount,
              })
            }
          >
            <IoOpen />
          </Button>
          <Button
            themeColor={"tertiary"}
            type="button"
            fillMode="outline"
            size="small"
            title="Close"
            onClick={() =>
              handleLeadTypeStatus(props.dataItem.LeadGUID, {
                InquiryStatus: "CLOSED",
                status: 1,
                LeadID: props.dataItem.LeadID,
                GroupCode: props.dataItem.GroupCode,
                OpenCount: props.dataItem.OpenCount,
                CloseCount: props.dataItem.CloseCount,
              })
            }
          >
            <TiLockClosedOutline />
          </Button>
        </Tooltip>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 7 || props.index === 8 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const gridRef = useRef<any>(null);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        className="disableFilterOprator responsive-table"
        filter={filter}
        data={filter ? filterBy(NBinquiryList, filter) : NBinquiryList}
        onFilterChange={handleFilterChange}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="LeadName"
          title="Client Name"
          filterCell={MyCustomFilterCell}
          width={200}
          cell={(props: any) => (
            <td>
              <div
                className="hoverableName"
                onClick={() => {
                  navigate("/nbinquiry/edit", {
                    state: {
                      NBInquiryGUID: props.dataItem?.NBInquiryGUID,
                      LeadID: props.dataItem?.LeadID,
                      LeadName: props.dataItem?.LeadName,
                    },
                  });
                  isEditRef.current = true;
                }}
              >
                {props.dataItem?.LeadName}
              </div>
            </td>
          )}
        />
        <Column
          field="GroupCode"
          title="Group Code"
          width={150}
          filterCell={MyCustomFilterCell}
        />
        <Column
          field="LeadStageID"
          title="Client Type"
          width={150}
          cell={(props) => (
            <td>
              {props.dataItem?.LeadStageID === 1
                ? "Existing"
                : props.dataItem?.LeadStageID === 2
                ? "Prospect"
                : ""}
            </td>
          )}
        />

        <Column
          field="MobileNo"
          title="Mobile No"
          width={150}
          filterCell={MyCustomFilterCell}
        />
        <Column field="EmailID" title="Email" width={300} />
        <Column
          field="AllotmentName"
          title="Allotment To"
          width={200}
          filterCell={MyCustomFilterCell}
        />
        <Column
          field="OccupationName"
          title="Occupation"
          width={200}
          filterCell={MyCustomFilterCell}
        />
        {/* <Column
            field="Open"
            title="Types"
            cell={MyNbInquiryTypesCheck}
            width={"150px"}
            filterable={false}
            locked={true}
          /> */}
        <Column
          field="Open"
          title="Status"
          cell={MyNbInquiryStatusCheck}
          width={"110px"}
          filterable={false}
          locked={true}
        />
        {isEditAccess && (
          <Column
            field="NBInquiryGUID"
            title="Actions"
            cell={MyEditCommandCell}
            width={"95px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

// const DeleteNBinquiryDialog: React.FC = () => {
//   const dispatch = useAppDispatch();
//   const NBinquiryID = useAppSelector((state) => state.nbinquiry.NBinquiryID);
//   const dialogName = useAppSelector((state) => state.dialog.dialogName);
//   const currentPage = useAppSelector((state) => state.pagination.currentPage);
//   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

//   const handleDeleteAction = async (ID: number | null) => {
//     if (ID) {
//       const response = await dispatch(deleteNBinquiry(ID));
//       dispatch(setCurrentPage(0));
//       const payload = {
//         LeadSearch: "",
//         limit: +pageLimit,
//         skip: +currentPage * +pageLimit,
//       };
//       if (response.payload?.Data.Status === 200) {
//         dispatch(findAllActiveNBinquiry(payload));
//         dispatch(closeDialog());
//         dispatch(clearNBinquiryID());
//       } else {
//         dispatch(findAllActiveNBinquiry(payload));
//         dispatch(closeDialog());
//         dispatch(clearNBinquiryID());
//       }
//     }
//   };

//   return (
//     <>
//       {dialogName === "deleteNBinquiry" && (
//         <AppDialog>
//           <>
//             <Typography.h5>{"Delete NBinquiry ?"}</Typography.h5>
//             <GridLayout>
//               <GridLayoutItem>
//                 <Typography.p>
//                   Are you sure you want to delete this NBinquiry?
//                 </Typography.p>
//               </GridLayoutItem>
//               <GridLayoutItem
//                 style={{
//                   display: "flex",
//                   justifyContent: "end",
//                 }}
//               >
//                 <DialogCloseButton themeColor="error" />
//                 <Button
//                   fillMode={"solid"}
//                   themeColor={"error"}
//                   onClick={() => {
//                     handleDeleteAction(NBinquiryID);
//                   }}
//                   type="button"
//                 >
//                   Delete
//                 </Button>
//               </GridLayoutItem>
//             </GridLayout>
//           </>
//         </AppDialog>
//       )}
//     </>
//   );
// };

const MyCustomFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterCustomNBInquiry: any = useAppSelector(
    (state) => state.nbinquiry.FilterCustomNBInquiry
  );

  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      dispatch(setCurrentPage(0));
      const payload = {
        ...updatedFilters,
        limit: +pageLimit,
        skip: 0 * +pageLimit,
      };

      dispatch(findAllActiveNBinquiry(payload));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = {
        ...FilterCustomNBInquiry,
        [inputField]: inputValue,
      };
      dispatch(setFilterCustomNBInquiry(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FilterCustomNBInquiry, [props.field]: "" };
    dispatch(setFilterCustomNBInquiry(updatedFilters));

    const payload = {
      ...updatedFilters,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };

    dispatch(findAllActiveNBinquiry(payload));
  };

  return (
    <div className="d-flex">
      <TextBox
        value={FilterCustomNBInquiry[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FilterCustomNBInquiry[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

export default NBinquiry;
